import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../../components/header/header.component';
import { SidenavComponent } from '../../../components/sidenav/sidenav.component';
import { ProjectService } from '../../../services/project.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, RouterOutlet, HeaderComponent, SidenavComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  private readonly projectService = inject(ProjectService);

  sidebarVisible = true; // Start with sidebar visible

  ngOnInit(): void {
    // Load all projects when the dashboard loads
    // This will populate the sidenav with project items
    this.projectService.loadAllProjects();
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }
}
